import { render } from "./CadastroLicencaOrgao.vue?vue&type=template&id=7e98d661"
import script from "./CadastroLicencaOrgao.vue?vue&type=script&lang=ts"
export * from "./CadastroLicencaOrgao.vue?vue&type=script&lang=ts"
script.render = render

export default script